export const getCantiqueUrl = (cantique) =>
  `${window.location.origin}/cantiques/${encodeURIComponent(cantique.id || cantique._id)}`

const legacyCopy = (text) => {
  const field = document.createElement('textarea')
  field.value = text
  field.setAttribute('readonly', '')
  field.style.position = 'fixed'
  field.style.opacity = '0'
  document.body.appendChild(field)
  field.select()
  let copied = false
  try {
    copied = document.execCommand('copy')
  } catch (_err) {
    copied = false
  }
  document.body.removeChild(field)
  return copied
}

// Returns 'shared' | 'copied' | 'cancelled' | 'manual'.
// navigator.share and navigator.clipboard only exist on https (or localhost),
// hence the fallbacks for a phone opening the dev server over plain http.
export const shareCantique = async (cantique) => {
  const url = getCantiqueUrl(cantique)
  const title = `${cantique.number ? `${cantique.number}. ` : ''}${String(cantique.title || '').trim()}`

  if (navigator.share) {
    try {
      await navigator.share({ title, text: `Cantique ${title}`, url })
      return 'shared'
    } catch (err) {
      if (err?.name === 'AbortError') return 'cancelled'
    }
  }

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(url)
      return 'copied'
    } catch (_err) {
      // fall through
    }
  }

  if (legacyCopy(url)) return 'copied'

  window.prompt('Copiez le lien du cantique :', url)
  return 'manual'
}
